{
  "version": 1,
  "asset_id": "b970394f-bb87-4466-b048-31b47da30eaa",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b970394f-bb87-4466-b048-31b47da30eaa/hiatal-type-1-es-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b970394f-bb87-4466-b048-31b47da30eaa/hiatal-type-1-es-v3-800.webp",
  "original_filename": "hiatal-type-1-es-v3-800.webp",
  "size": 87422,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:09:25Z"
}
